fx.ns("shared.components", class CoverThumbShape extends shared.components.CoverThumb 
{    
    constructor(parameters)
    {
        super(parameters);
    }

    load()
    {
        super.load();
        
        var shape = this.model.shapes.find({id : this.data.content});

        if (shape)
        {
            var match = shape.svg.match(/d="(.*)"/);
            var path = new Path2D(match[1]);
            this.context.save();
            this.context.translate(this.elementX-this.offset, this.elementY-this.voffset);
            this.context.rotate(this.elementRotation*this.TO_RADIANS);
            this.context.translate(-(this.elementX-this.offset), -(this.elementY-this.voffset));
            this.context.translate(this.elementX-this.offset, this.elementY-this.voffset);
            this.context.scale(this.elementWidth / shape.width, this.elementHeight / shape.height);
            this.context.fillStyle = this.data.bgcolor;
            this.context.fill(path);

            if(this.data.borderid>0)
            {
                this.context.lineWidth = this.data.borderid / (this.elementWidth / shape.width) * this.creationSize.ratio; // TODO : check if scale is needed
                this.context.strokeStyle = this.data.side;
                this.context.stroke(path);
            }

            this.context.restore();
            
        }

        this.ready();
    }
});